var _jsxFileName = "/repo/packages/ippm/src/components/PackagesContainer/index.js",
  _this = this;
import React from 'react';
import classNames from 'classnames';
import { Grid, Row } from '@sm/wds-react';
import { useAppContext } from '../../utils/appContext';
import { useConfiguredExperimentContext } from '../../utils/experimentContext';
import getRecommendationStrategyClass from '../../utils/recommendationStrategy';
import { PLAN_TYPES, INDIVIDUAL_PLAN_IDS_WITH_MONTHLY, STARTER_ANNUAL_V2_INDIVIDUAL, TEAMS_PLAN_IDS, PACKAGE_IDS } from '../../constants/plans';
import Package from '../Package';
import './PackagesContainer.scss';
function getPackageIdsToDisplay(_ref) {
  var displayedPlanType = _ref.displayedPlanType,
    experimentsConfig = _ref.experimentsConfig;
  if (displayedPlanType === PLAN_TYPES.INDIVIDUAL) {
    // GROW-1898
    if (experimentsConfig.GROW_1898_STARTER_ANNUAL_V2) {
      return STARTER_ANNUAL_V2_INDIVIDUAL;
    }
    return INDIVIDUAL_PLAN_IDS_WITH_MONTHLY;
  }
  if (displayedPlanType === PLAN_TYPES.TEAMS) {
    if (experimentsConfig.IG1453_REMOVE_TEAM_PREMIER) {
      return TEAMS_PLAN_IDS.filter(function (id) {
        return id !== PACKAGE_IDS.TEAMS_PREMIER;
      });
    }
    return TEAMS_PLAN_IDS;
  }
  // TODO: log error to splunk
  // console.error(`Unknown plan type: ${displayedPlanType}`);
  return INDIVIDUAL_PLAN_IDS_WITH_MONTHLY;
}
function getPackagesToDisplay(_ref2) {
  var packages = _ref2.packages,
    displayedPlanType = _ref2.displayedPlanType,
    experimentsConfig = _ref2.experimentsConfig;
  var getPackageById = function getPackageById(id) {
    return packages.filter(function (x) {
      return x.id === id;
    })[0];
  };
  var packageIds = getPackageIdsToDisplay({
    displayedPlanType: displayedPlanType,
    experimentsConfig: experimentsConfig
  });
  return packageIds.map(function (id) {
    return getPackageById(id);
  }).filter(function (x) {
    return x !== undefined;
  });
}
var PackagesContainer = function PackagesContainer() {
  var _useAppContext = useAppContext(),
    packages = _useAppContext.packages,
    displayedPlanType = _useAppContext.displayedPlanType,
    addedPaidFeatures = _useAppContext.addedPaidFeatures;
  var experimentsConfig = useConfiguredExperimentContext();
  var packagesToDisplay = getPackagesToDisplay({
    packages: packages,
    displayedPlanType: displayedPlanType,
    experimentsConfig: experimentsConfig
  });
  var gridClassNames = classNames('packages-container wds-m-t-4 wds-p-b-6', "packages--".concat(packagesToDisplay.length));
  var rowClassNames = classNames('margin-auto', 'space-between', 'width-fixed', {
    center_content: packagesToDisplay.length < 3
  });
  var isPackageRecommended = function () {
    var RecommendedPackagesStrategy = getRecommendationStrategyClass({
      displayedPlanType: displayedPlanType
    });
    var recommendationStrategy = new RecommendedPackagesStrategy({
      packages: packages,
      addedPaidFeatures: addedPaidFeatures
    });
    return function (packageId) {
      return recommendationStrategy.isRecommended(packageId);
    };
  }();
  return /*#__PURE__*/React.createElement(Grid, {
    className: gridClassNames,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Row, {
    className: rowClassNames,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 7
    }
  }, packagesToDisplay.map(function (packageData) {
    return /*#__PURE__*/React.createElement(Package, {
      packageData: packageData,
      isRecommended: isPackageRecommended(packageData.id),
      key: packageData.id,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88,
        columnNumber: 13
      }
    });
  })));
};
export default PackagesContainer;